import { FC } from "react";

import { Box } from "@mui/material";
import { DafProvider } from "@simplyk/common";

import { FormIcon } from "@/forms-design-system/FormIcon";
import { Bank } from "@/icons/outlined";

const PROVIDER_LOGOS = {
  fidelity: "/assets/daf-providers/fidelity.png",
  bny: "/assets/daf-providers/bny.png",
  dafgiving360: "/assets/daf-providers/dafgiving360.png",
};

interface ProviderLogoProps {
  provider: DafProvider;
}

export const ProviderLogo: FC<ProviderLogoProps> = ({ provider }) => {
  const logo = provider.dafDirect ? PROVIDER_LOGOS[provider.dafDirect] : undefined;
  return (
    <Box
      data-test="daf-provider-logo"
      sx={(theme) => ({
        width: theme.spacing(6),
        height: theme.spacing(6),
        borderRadius: theme.radius(0.5),
        overflow: "hidden",
        flexShrink: 0,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        ...(!logo && { backgroundColor: theme.palette.forms.surface.quiet, color: theme.palette.forms.text.brand }),
        ...(provider.dafDirect === "bny" && {
          backgroundColor: "#092a48",
        }),
      })}
    >
      {logo ? (
        provider.dafDirect === "bny" ? (
          <Box
            sx={(theme) => ({
              position: "relative",
              overflow: "hidden",
              width: theme.spacing(5.625),
              height: theme.spacing(3),
            })}
          >
            <Box
              component="img"
              alt=""
              src={logo}
              sx={{
                position: "absolute",
                width: "121.9%",
                height: "171.43%",
                left: "-7.62%",
                top: "-35.71%",
                maxWidth: "none",
              }}
            />
          </Box>
        ) : (
          <Box
            component="img"
            alt=""
            src={logo}
            sx={{ display: "block", width: "100%", height: "100%", objectFit: "cover" }}
          />
        )
      ) : (
        <FormIcon size="large">
          <Bank />
        </FormIcon>
      )}
    </Box>
  );
};
